<dx-popup #dlgTenderVoucher [width]="600" [height]="400" [showTitle]="true" title="Tender Voucher" [resizeEnabled]=true
    [dragEnabled]="true" [showCloseButton]="true" [hideOnOutsideClick]="false">

    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="CancelButtonOptions">
    </dxi-toolbar-item>

    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="OkButtonOptions">
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'">
        <app-voucher-input (VoucherChanged)="VoucherChanged($event)" ></app-voucher-input>
        <app-voucher-details [showHistory]="false" [voucherDetails]="details" message=""></app-voucher-details>        
        <div *ngIf="message.length>0" style="font-weight: 900;font-size: large;">
            {{message}}
        </div>        
    </div>
</dx-popup>
